import React, { ReactNode, useState, ChangeEvent, HTMLInputTypeAttribute } from 'react';
import EyeOpen from '../../assets/svgs/eyeOpen';
import EyeClosed from '../../assets/svgs/eyeClosed';
import { InputNumberChangeEvent } from 'primereact/inputnumber';

interface MyInputProps {
  labelViaPlaceholder?: boolean;
  type?: any;
  classes?: any;
  color?: any;
  onChange: (value: string) => void;
  onChangeEvent?: (event: ChangeEvent<HTMLInputElement>) => void;
  label?: any;
  placeholder?: string;
  value?: string;
  isError?: any;
  children?: ReactNode;
  onKeyDown?: any;
  isLengthActive?: boolean;
  maxLength?: number;
  isDiasbled?: boolean;
  isErrorMessage?: boolean;
  myInputRef?: any;
  onKeyPress?: any;
  isDefaultError?: string;
  isDefaultErrorMessage?: string;
  isRequired?: boolean,
  options?: any,

}

const MyInput: React.FC<MyInputProps> = ({
  labelViaPlaceholder,
  color,
  label,
  classes,
  placeholder,
  value,
  type,
  onChange,
  onChangeEvent,
  onKeyPress,
  isError,
  children,
  onKeyDown,
  isLengthActive,
  isDiasbled,
  isErrorMessage,
  isDefaultErrorMessage,
  isDefaultError,
  myInputRef,
  maxLength = Infinity, // Varsayılan değer sınırsız
  isRequired,
  options,
  ...rest
}) => {
  const [text, setText] = useState<string>('');

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {

    if (onChangeEvent) {
      return onChangeEvent(event)
    }
    const newText = event.target.value;
    if (newText.length <= maxLength) {
      setText(newText);

      if (typeof onChange === 'function') {
        onChange(newText);
      }
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex flex-col w-[100%] relative">
      <div className="relative">
        {!labelViaPlaceholder && label && (
          <label
            className={`block mb-2 text-sm font-medium text-gray-900 ${isError ? 'text-red-500' : 'text-stale-400'} ${!label ? 'none' : ''
              }`}
          >
            {label}
          </label>
        )}
        <input
          {...rest}
          min={options?.min}
          max={options?.max}
          step={options?.step}
          required={isRequired}
          disabled={isDiasbled}
          type={type === 'password' && showPassword ? 'text' : type}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          onKeyPress={onKeyPress}
          ref={myInputRef}
          value={typeof value === "number" && value !== undefined && value !== null ? value : (value || text)} // Değer controlled hale getirildi
          onChange={e => handleInputChange(e)}
          className={`bg-white border h-[45px] text-gray-900 text-sm rounded-[5px]
                 border-[#E3E8EF]  focus:outline-none focus:ring-[#7059EF] focus:border-[#7059EF] block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${(isError && (value || text).length === 0) || (isDefaultError && (value || text).length !== 0)
              ? 'border-red-500'
              : 'border-slate-300'
            } ${classes}`}
        />
        {type === 'password' && (
          <div className="absolute flex justify-center right-0 h-full pt-2 px-3 top-0">
            <button type="button" onClick={togglePasswordVisibility}>
              {showPassword ? (
                <EyeOpen onClick={togglePasswordVisibility} className="cursor-pointer" />
              ) : (
                <EyeClosed onClick={togglePasswordVisibility} className="cursor-pointer" />
              )}
            </button>
          </div>
        )}
      </div>
      {isLengthActive && maxLength !== Infinity && (
        <div className="absolute right-2 bottom-[-23px]  flex items-center gap-[10px]">
          <span className="text-gray-500 text-[10pt] ">{`${(value || text).length}/${maxLength}`}</span>
          {((isErrorMessage && (value || text).length === 0) ||
            (isDefaultErrorMessage && (value || text).length !== 0)) && (
              <div className="">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.13231 1.35159C5.65385 0.450529 6.41462 2.04294e-08 7.25 0C8.08538 -2.04294e-08 8.84615 0.450528 10.3677 1.35159L10.8823 1.65634C12.4038 2.5574 13.1646 3.00793 13.5823 3.75C14 4.49207 14 5.39313 14 7.19524V7.80476C14 9.60687 14 10.5079 13.5823 11.25C13.1646 11.9921 12.4038 12.4426 10.8823 13.3437L10.3677 13.6484C8.84615 14.5495 8.08538 15 7.25 15C6.41462 15 5.65385 14.5495 4.13231 13.6484L3.61769 13.3437C2.09615 12.4426 1.33538 11.9921 0.917691 11.25C0.5 10.5079 0.5 9.60687 0.5 7.80476V7.19524C0.5 5.39313 0.5 4.49207 0.917691 3.75C1.33538 3.00793 2.09615 2.5574 3.61769 1.65634L4.13231 1.35159ZM8 10.5C8 10.9142 7.66421 11.25 7.25 11.25C6.83579 11.25 6.5 10.9142 6.5 10.5C6.5 10.0858 6.83579 9.75 7.25 9.75C7.66421 9.75 8 10.0858 8 10.5ZM7.25 3.1875C7.56066 3.1875 7.8125 3.43934 7.8125 3.75V8.25C7.8125 8.56066 7.56066 8.8125 7.25 8.8125C6.93934 8.8125 6.6875 8.56066 6.6875 8.25V3.75C6.6875 3.43934 6.93934 3.1875 7.25 3.1875Z"
                    fill="#E23D47"
                  />
                </svg>
              </div>
            )}
        </div>
      )}
      {children}

      {((isError && (value || text).length === 0) || (isDefaultError && (value || text).length !== 0)) && (
        <div className="flex items-start mt-1">
          <span className="text-red-500 text-[10pt]">{isErrorMessage || isDefaultErrorMessage}</span>
        </div>
      )}
    </div>
  );
};

export default MyInput;
